export default (value) => {
    let tmpValue = value;
    typeof tmpValue === 'string'
        ? (tmpValue = tmpValue.replace(/[^\-0-9]/g, ''))
        : '';
    return Number(tmpValue) > 0 ? `+${value}` : value;
};
